import { MyReferralsResponseI } from './interfaces/Referrals';
import { MOCK_MY_REFERRALS, MOCK_MY_REFERRALS_EMPTY } from './mockData';

// GET /referrals/me
// Returns all referral data for the authenticated user in a single call:
// their code/url, invited users (attributions), generated rewards, and aggregated stats.
// See MyReferralsResponseI for the full expected shape.
const getMyReferrals = async (token: string): Promise<MyReferralsResponseI> => {
	if (process.env.REACT_APP_MOCK_REFERRALS === 'true') {
		// To force empty state from browser console: localStorage.setItem('mock_referrals_empty', 'true')
		const isEmpty =
			process.env.REACT_APP_MOCK_REFERRALS_EMPTY === 'true' ||
			localStorage.getItem('mock_referrals_empty') === 'true';
		return Promise.resolve(isEmpty ? MOCK_MY_REFERRALS_EMPTY : MOCK_MY_REFERRALS);
	}

	const response = await fetch(`${process.env.REACT_APP_BASE_API}/referrals/me`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	if (!response.ok) {
		let detail = 'Unknown error';
		try {
			const body = await response.json();
			detail = (body as { message?: string }).message ?? detail;
		} catch {} // eslint-disable-line no-empty
		throw new Error(`HTTP ${response.status}: ${detail}`);
	}

	// Comparsa envuelve toda respuesta correcta en ArcaResponse { data, code, ... }
	const body = (await response.json()) as { data: MyReferralsResponseI };
	return body.data;
};

export default getMyReferrals;
